export default {
  en: {
    general: {
      searchAll: 'search all',
      pleaseContactUs: 'Please contact us for the additional assistance.',
      editThisAccount: 'Edit This Account',
    },
    btn: {
      addNew: 'ADD NEW',
      Download: 'Download',
      metrics: 'Metrics',
      cancelLastChanges: 'cancel last changes',
      confirmBtn: 'Confirm',
      acceptResults: 'Accept Results',
      verifyAndGenerate: 'Verify and Generate',
      addAssessment: 'Add Assessment',
      enableClaim: 'Enable Claim',
      clearFilter: 'Clear Filter',
      applyChanges: 'Apply Changes',
      login: 'Login',
      proceed: 'Proceed',
      forgotPassword: 'Forgot Password?',
      cancel: 'Cancel',
      remove: 'Remove',
      save: 'Save',
      modifyDemographics: 'Modify Demographics',
      submit: 'Submit',
      send: 'Send',
      sendCode: 'Send Code',
      confirmAndContinue: 'Confirm and Continue',
      create: 'Create',
      patient: 'Patient',
      addPatient: 'Add Patient',
      editPatient: 'Edit Patient',
      addAccount: 'Add Account',
      addOrder: 'Add Order',
      createAccount: 'Create Account',
      generateReport: 'Generate Report',
      createPatient: 'Create Patient',
      createOrder: 'Create Order',
      createProgram: 'Create Program',
      programs: 'Programs',
      contactSupport: 'Contact Support',
      copyToClipboard: 'Copy This Section',
      createAssessment: 'Create Assessment',
      createResource: 'Add Resource',
      select: 'Select',
      readMore: 'Read More',
      back: 'Back',
      selected: 'Selected',
      current: 'Current',
      setPasswordLogIn: 'Set Password',
      updatePassword: 'Update password',
      export: 'Export',
      close: 'Close',
      openAssessmentIntoNewTab: 'Open Assessment In New Browser Tab',
      acceptContinue: 'Accept & Continue',
      ok: 'Ok',
      logOut: 'Log Out',
      stayLoggedIn: 'Stay Logged In',
      resendInvitation: 'Resend Invitation',
      goToListOfPatients: 'Go to list of patients',
      orders: 'Orders',
      assessments: 'Assessments',
      resource: 'Resources',
      billing: 'Billing',
      billingReports: 'Billing Reports',
      claimsReporting: 'Claims',
      claimReport: 'Claim Report',
      reportable: 'Reportable',
      takeInClinic: 'Take In-Clinic',
      sendAnInvite: 'Send an Invite',
      closeAll: 'Close All',
      expandAll: 'Expand All',
      default: 'Default',
      apply: 'Apply',
      applyFilter: 'Apply Filter',
      applySorting: 'Apply Sorting',
      downloadPDF: 'Download Outstanding Claim Report',
      downloadCSV: 'Download CSV',
      downloadZIP: 'Download ZIP',
      download: 'Download',
      refresh: 'Refresh',
      acknowledge: 'Acknowledge',
      noReportsToCompare: 'There are no other reports to compare yet.',
      selectorEndMessage: 'Yay! You have seen it all',
      searchByICDCode: 'Search by ICD code',
      continue: 'Continue',
      selectAllOption: 'Select All Option',
      deleting: 'Deleting...',
      permanentlyDeleteUser: 'Permanently Delete',
      retry: 'Retry',
      retryAndClearFilters: 'Retry and clear filters',
    },
    nav: {
      resetPassword: 'Reset Password',
      logOut: 'Log Out',
      build: 'Build',
      env: 'ENV',
      dev: 'DEV',
      testing: 'TESTING',
      qhsLabs: 'Verdin Labs',
      privacy: 'Privacy',
      terms: 'Terms',
      hippa_baa: 'HIPPA BAA',
    },
    titles: {
      deleteUser: 'Remove Account Access',
      deleteUserLoading: 'Loading user information...',
      deleteUserSubtitle: 'User will be permanently removed from this account',
      deleteUserSubtitle2: 'User will be permanently removed from these accounts',
      deleteUserFinalTitle: 'Final Authorization Required',
      resource: 'resource',
      allowedAccounts: 'Allowed Accounts',
      availableAccounts: 'Available Accounts',
      selectedAccounts: 'Selected Accounts',
      noAccountsSelected: 'No accounts selected',
      unlimitedAccessEnabled: 'Unlimited access is enabled',
      unlimitedAccessDescription: 'This user has access to all accounts. Select specific accounts from the table to restrict access.',
      selectAccountsFromTable: 'Select accounts from the table on the left',
      removeFromSelection: 'Remove from selection',
      multipleSelection: 'Multiple Selection',
      instantAssessment: 'Instant Assessment',
      acknowledge: 'Acknowledge',
      oneMore: 'Some Action with modal',
      alerts: 'Alerts',
      cpts: 'CPTs',
      aspects: 'Aspects',
      responses: 'Responses',
      cpt: 'CPT',
      noShow: 'No Show',
      reverseNoShow: 'No Show Reversal',
      accountCptCodes: 'Account CPT Codes',
      preview: 'preview',
      noAccountSelected: 'No account selected',
      displayedColumns: 'Displayed columns',
      assessmentInProgress: 'Assessment In Progress',
      someDataNotAvailable: 'Some data may not be available yet',
      claimReports: 'Claim Reports',
      reportables: 'Reportables',
      botActivities: 'Bot Activity',
      reported: 'Reported',
      downloadReport: 'Download Report',
      accepted: 'Accepted',
      items: 'items',
      notFound: 'Not Found',
      dashboard: 'Dashboard',
      populationHealth: 'Population Health',
      // TEMP: Assessment Performance backport (2026-05-07) — orphan after FSD merge.
      assessmentPerformance: 'Assessment Performance',
      rootPage: 'Root Page',
      open: 'Open',
      claimsReporting: 'Claims',
      claims: 'claims',
      editClaim: 'Edit Claim',
      patientUpload: 'Upload Patients',
      insuranceUpload: 'Upload Insurance',
      providersUpload: 'Upload Providers',
      claimsUpload: 'Upload Claims',
      downloadPracticeOptimizationReport: 'Download Practice Optimization Report',
      practiceOptimizationReport: 'Practice Optimization Report',
      enableClaim: 'Enable Claim for This {{source}}',
      enableClaimSubtitle:
        'A claim will be enable for this {{source}}. To remove the claim (undo this operation), mark the claim as Not Billable from the Claims area.',
      patientUploadForAccount: 'Patient Upload for {{accountName}}',
      insuranceUploadForAccount: 'Insurance Upload for {{accountName}}',
      claimsUploadForAccount: 'Claims Upload for {{accountName}}',
      providersUploadForAccount: 'Providers Upload for {{accountName}}',
      editProfile: 'Edit Profile',
      changePassword: 'Change Password',
      accounts: 'Accounts',
      selectAndUploadFile: 'Select And Upload File',
      itemSuccessfullyImported: '{{item}} successfully imported',
      insurance: 'Insurance',
      providers: 'Providers',
      Claims: 'Claims',
      importPatients: 'Import Patients',
      validate: 'Validate',
      account: 'Account',
      createAccount: 'Create Account',
      editAccount: 'Edit Account',
      viewAccountDetails: 'View Account Details',
      removeAccount: 'Remove Account',
      readOnlyNoPermissions: 'Read-only: No permissions to edit this account',
      editUsers: 'Edit Users',
      users: 'Users',
      user: 'User',
      testDate: 'Test Date',
      viewBillingReport: 'View Billing Report',
      addNewPatient: 'Add Patient',
      createNewAssessment: 'Create New Assessment',
      createNewResource: 'Create New Resource',
      accountUsers: 'Account Users',
      managesUsers: 'Administrator',
      globalUsersManagement: 'Users',
      administerClaims: 'Administer Claims',
      administerClaimReports: 'Administer Claim Reports',
      administerReportable: 'Administer Reportable',
      receiveClaimsEmails: 'Receive Claims Emails',
      receiveSurveysEmails: 'Receive Assessment Statistics Emails',
      managesAlert: 'Manages Alert',
      manageChildAccounts: 'Administrator of Child Accounts',
      imminentRiskEmails: 'Receive Imminent Risk Emails',
      managesUsersHint: 'You can modify account settings and users.',
      administerClaimsHint: 'Manage claims, claim reportables, and claim reports.',
      administerClaimReportsHint: 'Access and manage claim reports and reporting functionality.',
      imminentRiskEmailsHint: 'Will receive email notification for imminent risk patients.',
      receiveSurveysEmailsHint: 'Will receive periodic emails with assessment statistics.',
      receiveClaimsEmailsHint: 'Will receive periodic emails with claim statistics.',
      managesAlertHint:
        "Alerts will be considered 'read' if viewed by a user with this option. Can also take action on alerts, such as acknowledging them.",
      manageChildAccountsHint: 'Access to edit accounts.',
      createUser: 'Create User',
      removeUser: 'Remove User',
      editUser: 'Edit User',
      manageUserAccounts: 'User Account Access',
      removeAccess: 'Remove Access',
      removeAccessConfirmation: 'Remove Access Confirmation',
      saveChanges: 'Save Changes',
      addAccountAccess: 'Add Account Access',
      searchAccounts: 'Search accounts...',
      noAccountsFound: 'No accounts found for',
      configureAccessPermissions: 'Configure access permissions and role details',
      areYouSureRemoveAccess: 'Are you sure you want to remove access to',
      warningPermissionsLost:
        'Warning: All permissions and settings for this account will be permanently lost and cannot be recovered.',
      currentAccount: 'Current',
      permissionsCount: 'permissions',
      patients: 'Patients',
      patient: 'Patient',
      editPatient: 'Edit Patient',
      createProgram: 'Create Program',
      selectRangeDate: 'Select Range Date',
      downloadClaim: 'Download Outstanding Claim Report',
      removePatient: 'Remove Patient',
      createPatient: 'Create Patient',
      editOrder: 'Edit Order',
      removeOrder: 'Remove Order',
      reorder: 'Reorder',
      createOrder: 'Create Order',
      createAssessment: 'Create Assessment',
      orders: 'Orders',
      order: 'Order',
      assessmentCreated: 'Assessment Created',
      resourceCreated: 'Resource Created',
      verifyInvitationDetails: 'Verify Invitation Details',
      assessments: 'Assessments',
      programs: 'Programs',
      reports: 'Reports',
      report: 'Report',
      billing: 'Billing',
      billingReports: 'Billing Reports',
      allergiEndResources: 'AllergiEnd Documents',
      resources: 'Resources',
      editAssessment: 'Edit Assessment',
      editBill: 'Edit Bill',
      removeBill: 'Remove Bill',
      patientDashboard: 'Patient Dashboard',
      programDashboard: 'Program Dashboard',
      removeAssessment: 'Remove Assessment',
      assessmentAdded: 'New Assessment Added',
      patientAdded: 'New Patient Added',
      invitationSent: 'Invitation Sent',
      loading: 'Loading...',
      pleaseWait: 'Please wait',
      nothingFound: 'Nothing found matching your request.',
      resendInvitation: 'Resend Invitation',
      generateClaim: 'Generate Claim',
      viewAssessmentLink: 'View Assessment Link',
      generateProgramClaim: 'Generate Program Claim',
      downloadProgram: 'Download Program',
      downloadCounselingReport: 'Download Counseling Report',
      downloadImmunotherapyReport: 'Download Immunotherapy Report',
      reportNavigation: 'report navigation',
      linkWillBeProvided: 'A link will be provide after the assessment is created.',
      downForMaintenance: 'Down for maintenance.',
      downForMaintenanceSubtitleFirst:
        "We're currently working on some updates to our platform and will be down in the meantime.",
      downForMaintenanceSubtitleSecond: 'Thank you for your patience.',
      openThisPage:
        'Open this page on the appropriate device and allow the patient to complete the assessment. Once completed, you will receive next steps for processing.',
    },
    forms: {
      ID: 'ID',
      address: 'Address',
      loading: 'Loading...',
      undo: 'Undo',
      time: 'Time',
      date: 'Date',
      selectAllInfo:
        'Use this button to enable access for all accounts that are currently visible in the list.',
      allAccountsSelected: 'All accounts selected. ',
      selectAll: 'Select all',
      allowedResources: 'Allowed Resources',
      allowedSurveys: 'Allowed Assessments',
      addresses: 'Addresses',
      chooseAnAccount: 'Choose an account',
      encounterStatus: 'Encounter Status',
      patientLanguage: 'Patient Language',
      dos: 'Date of Service',
      insurance: 'Insurance',
      cptInfo: 'CPT Info',
      billingStatus: 'Billing Status',
      location: 'Location',
      appointmentProvider: 'Appointment Provider',
      checkDate: 'Check Date',
      paymentDate: 'Payment Date',
      paymentMethod: 'Payment Method',
      prType: 'PR Type',
      claimGeneratedTimestamp: 'Claim Created',
      createdBy: 'Created By',
      lastModifiedTimestamp: 'Modified Date',
      modifiedBy: 'Modified By',
      cptCode: 'CPT Code',
      price: 'Price',
      initialPrice: 'Initial Price',
      accountName: 'Account Name',
      deliverInvitationBy: 'Deliver Invitation By',
      orderType: 'Order Type',
      email: 'Email',
      password: 'Password',
      firstName: 'First Name',
      lastName: 'Last Name',
      features: 'Features',
      claimReportType: 'Claim Report Type',
      phone: 'Phone',
      preferredPhone: 'Preferred Phone',
      preferredPhoneDescription:
        'This field displays the primary telephone number as recorded by the patient and cannot be modified through the administrative interface.',
      confirmPassword: 'Confirm Password',
      confirmCode: 'Confirm Code',
      hasEmailSubscription: 'Email Subscription',
      hasEmailSubscriptionDescription:
        'The patient has given written or verbal consent to receive Email messages.',
      smsOptIn: 'SMS Opt-In',
      smsOptInDescription:
        'This patient has given written or verbal consent to receiving SMS messages.',
      bhiStatus: 'BHI Status',
      bhiStatusDescription:
        'Indicates whether the patient is enrolled in Behavioral Health Integration (BHI).',
      bhiStatusHint:
        'This value is managed by the system and cannot be changed manually.',
      distributionSponsor: 'Distribution Sponsor',
      updatePatientRecord: 'Update patient record',
      updatePatientRecordEmail: 'Update patient record with this email',
      updatePatientRecordPhone: 'Update patient record with this phone',
      businessName: 'Business Name',
      tradeName: 'Trade Name',
      sameAsBusinessName: 'Same as Business Name',
      fax: 'Fax',
      contactName: 'Contact Name',
      headProviderName: 'Head Provider Name',
      customId: 'Custom ID',
      name: 'Name',
      link: 'Link',
      streetAddress: 'Street Address',
      suite: 'Suite',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code',
      basicInfo: 'Basic info',
      organizationAddress: 'Organization Address',
      overrideDefaultMessage: 'Override Default Message',
      useDefaultMessage: 'Use Default Message',
      survey: 'Assessment',
      resource: 'Resource',
      english: 'English',
      spanish: 'Spanish',
      invitationEmail: 'Invitation Email',
      invitationSMS: 'Invitation SMS',
      reminderEmail: 'Reminder Email',
      reminderSMS: 'Reminder SMS',
      completionEmail: 'Completion Email',
      completionSMS: 'Completion SMS',
      editAccountScreen: 'Edit Account screen',
      scheduledActivities: 'Scheduled Activities',
      ianaTimeZone: 'Time Zone',
      scheduleDeliverTime: 'Scheduled Delivery Time',
      scheduledDate: 'Scheduled Delivery Date',
      scheduleDeliverDate: 'Scheduled Delivery Date',
      scheduleDeliverData: 'When do you want to sent it?',
      shippingAddress: 'Shipping Address',
      accountType: 'Account Type',
      useSameAddress: 'Use the same as organization address',
      enableOrders: 'Orders',
      enableAllergiEndResources: 'AllergiEnd Documents',
      enableAssessments: 'Assessments',
      enableInstantAssessment: 'Instant Assessment',
      enableResources: 'Resources',
      enableClaimsManagement: 'Claims Management',
      enableImmunotherapyReport: 'Immunotherapy Report',
      enableIntellyChart: 'IntellyChart',
      disableOrdersAutomations: 'Orders Automations',
      otherAddresses: 'Other Addresses',
      addAddress: 'Add Address',
      manageCpts: 'Manage CPT codes',
      removeAddress: 'Remove Address',
      userDetails: 'User Details',
      userRoleDetails: 'User Role Details',
      accountAccess: 'Account Access',
      selectAllFilteredItems: 'Select All {{filtered}}Items',
      unselectAllFilteredItems: 'Unselect All {{filtered}}Items',
      accountAccessNumber: 'Number of account{{end}} with access granted: {{number}}',
      accountAccessTotalNumber: 'Total number of selected account{{end}}: {{number}}',
      cptsTotalNumber: 'CPT Codes: {{number}}',
      selectAllAccounts: 'Select all accounts',
      modifyAccountAccessList: 'Modify Child Account Access List',
      title: 'Title',
      npiNumber: 'NPI Number',
      provider: 'Provider',
      assistant: 'Assistant',
      role: 'Role',
      mrnNumber: 'MRN #',
      bussinessName: 'Account Name',
      dateOfBirth: 'Date of Birth',
      scheduleDate: 'Schedule Date',
      gender: 'Gender',
      genderAtBirth: 'Gender at Birth',
      allergies: 'Allergies',
      drugAllergies: 'Drug Allergies',
      noDrugAllergies: 'No Drug Allergies',
      drugList: 'Drug List',
      yes: 'Yes',
      no: 'No',
      unknown: 'Unknown',
      servesDate: 'Serves Date',
      patientName: 'Patient Name',
      assistantType: 'Assistant Type',
      datePaid: 'Date Paid',
      ctpNumber: 'CPT Code',
      allowed: 'Allowed',
      notAllowed: 'Not Allowed',
      all: 'All',
      notes: 'Notes',
      paid: 'Paid',
      pr: 'PR',
      female: 'Female',
      male: 'Male',
      comments: 'Comments',
      slit: 'Slit',
      scit: 'Scit',
      ctpInfo: 'CTP Info',
      orderCategory: 'Order Category',
      sendNow: 'Send Now',
      scheduleForLater: 'Schedule for Later',
      allergens: 'Allergens',
      patient: 'Patient',
      maintenance: 'Maintenance',
      lowDose: 'Low Dose',
      quantity: 'Quantity',
      invitationWillBeSent:
        'Invitation will be sent to the patient’s contact information provided above.',
      invitationWillBeResent: 'Another invitation will be sent to the email/phone specified above',
      invitationWillBeSentSubtitle: 'An invitation will be sent to the email/phone specified above',
      acceptInvitation:
        "Your QHS account is almost ready, you'll just need to configure a password.",
      resetPasswordStep1:
        "Enter the email address you use to log in. We'll send you a confirmation code to verify your identity.",
      resetPasswordStep2:
        'You should receive an email from us within a few moments with a confirmation code. Enter that code below to continue',
      resetPasswordStep3:
        'Thanks {{name}}! The code was confirmed. Now set your new password below',
      appointmentTimestamp: 'Appointment Date',
      selectAppointmentProvider: 'Select Appointment Provider',
      selectInsuranceProvider: 'Select Insurance Provider',
      appointmentDate: 'Appointment Date',
      documentDate: 'Document Date',
      patientSeen: 'Patient Seen',
      documentUploaded: 'Document Uploaded',
      modifier: 'Modifier',
      icd: 'ICD',
      id: 'ID',
      DOS: 'Date of Service (DOS)',
      check: 'Check#',
      claimStatus: 'Claim Status',
      cptStatus: 'CPT Status',
      appointmentTime: 'Appointment Time',
    },
    tables: {
      program: 'Program',
      desc: 'DESC',
      asc: 'ASC',
      sortedBy: 'Sorted by: ',
      sortTableBy: 'Sort table by:',
      programName: 'Program Name',
      alertTags: 'Alert Tags',
      criticalCategory: 'Critical Category',
      alertName: 'Alert Name',
      acknowledged: 'Acknowledged',
      pendingAcknowledgment: 'Pending Acknowledgment',
      critical: 'Critical',
      description: 'Description',
      dateTriggered: 'Date Triggered',
      nonCritical: 'Non Critical',
      'monitor&support': 'Monitor & Support',
      name: 'Name',
      providerAssignment: 'Provider Assignment',
      uploadFailureReason: 'Failure Reason',
      documentUploadTimestamp: 'Activity Date',
      botUploadStatus: 'Bot Upload Status',
      eVisitFailureReason: 'E-Visit Failure Reason',
      eVisitUploadStatus: 'E-Visit Upload Status',
      eVisitUploadTimestamp: 'E-Visit Upload Timestamp',
      hasClaim: 'Has Claim',
      hasProgram: 'Has Program',
      hasIntellyChart: 'Has IntellyChart',
      instant: 'Instant',
      price: 'Price',
      remove: 'Remove',
      surveyTags: 'Assessment Tags',
      entityNameAlert: 'Alert source',
      entityType: 'Entity Source',
      TotalCount: 'Total Count',
      viewedBy: 'Viewed By',
      acknowledgeStatus: 'Acknowledge Status',
      acknowledgedBy: 'Acknowledged By',
      alertType: 'Alert Type',
      viewedTimestamp: 'Viewed Date',
      acknowledgedTimestamp: 'Acknowledged Date',
      createdTimestamp: 'Created',
      preFilter: 'Pre-Filter',
      preFilterHint:
        'Select “All” to see all options for this column. To pre-filter based on other column filters you’ve configured, choose “Pre-Filter”.',
      selectedOptions: 'Selected Options:',
      availableOptions: 'Available Options',
      allOptions: 'All Options',
      uncheckAllOptions: 'Uncheck all options',
      noAvailableOptions: 'No Available Options.',
      noSelectedOptions: 'No Selected Options.',
      addSomeTextToSearch: 'Start typing the name in the search to see the options.',
      cptCount: 'CPT Count',
      cptPaid: 'Paid CPTs Count',
      NotBillable: 'Not Billable',
      TotalBilledAmount: 'Total Billed Amount',
      TotalPaidAmount: 'Total Paid Amount',
      TotalPRAmount: 'Total PR Amount',
      TotalDeniedAmount: 'Total Denied Amount',
      AccountsCount: 'Accounts Count',
      TotalOutstandingAmount: 'Total Outstanding Amount',
      TotalPartiallyPaidAmount: 'Total Partially Paid Amount',
      TotalNotBillableAmount: 'Total Not Billable Amount',
      TotalNotBilledAmount: 'Total Not Billed Amount',
      assessmentResource: 'Assessment/Resource',
      entityName: 'Assessment/Resource',
      entityCompletedTimestamp: 'Completed Date',
      customId: 'Custom ID',
      accountCustomIdentifier: 'Custom ID',
      claimReportGeneratedTimestamp: 'Claim Report Generated Date',
      reportableGeneratedTimestamp: 'Reportable Generated Date',
      totalAmount: 'Total Amount',
      totalCount: 'Total Count',
      uniqueAccounts: 'Unique Accounts',
      totalPaidAmount: 'Total Reported Amount',
      totalUnpaidAmount: 'Total Reportable Amount',
      ViewedCount: 'Viewed Count',
      NotViewedCount: 'Not Viewed Count',
      PatientsCount: 'Patients Count',
      EngagedCount: 'Resources Engaged Count',
      EngageRate: 'Resources Engage Rate',
      totalCPTs: 'Total CPTs',
      generateClaimReport: 'Generate Claim Report',
      accessGranted: 'Access Granted',
      mrnNumber: 'Patient MRN',
      patientGender: 'Gender',
      female: 'Female',
      male: 'Male',
      patientMrnNumber: 'Patient MRN',
      createdBy: 'Created By',
      type: 'Type',
      manuallyCreated: 'Manually Created',
      integration: 'Integration',
      automated: 'Automated',
      automation: 'Automation',
      invitedTimestamp: 'Invitation Date',
      appointmentTimestamp: 'Appointment Date',
      engagedTimestamp: 'Engaged Date',
      firstName: 'First Name',
      lastName: 'Last Name',
      address: 'Address',
      more: 'More',
      roles: 'Roles',
      account: 'Account',
      accountBusinessName: 'Account',
      accountName: 'Account Name',
      numberOfClaimCPTLineItems: '# of Claim CPT Line Items',
      assessment: 'Assessment',
      patientName: 'Patient Name',
      patientFirstName: 'Patient First Name',
      patientLastName: 'Patient Last Name',
      orderTimestamp: 'Order Date',
      resource: 'Resource',
      patientDOB: 'Patient DOB',
      patientDateOfBirth: 'Patient DOB',
      orderType: 'Order Type',
      orderFormula: 'Order Formula',
      orderDate: 'Order Date',
      success: 'Success',
      error: 'Error',
      customTags: 'Custom Tags',
      patientCustomTags: 'Patient Custom Tags',
      accountCustomTags: 'Account Custom Tags',
      helpRequested: 'Help Requested',
      reviewed: 'Reviewed',
      claimGeneratedTimestamp: 'Claim Generated Date',
      entityOrderTimestamp: 'Order Date',
      cptCode: 'CPT Code',
      allowed: 'Allowed',
      pr: 'PR',
      modifier: 'Modifier',
      icd: 'ICD',
      dos: 'DOS',
      prType: 'PR Type',
      cptStatus: 'CPT Status',
      reportStatus: 'Report Status',
      expectedDeliveryDate: 'Expected Delivery Date',
      status: 'Status',
      encounterStatus: 'Encounter Status',
      paymentDate: 'Payment Date',
      lastModifiedTimestamp: 'Modified Date',
      modifiedBy: 'Modified By',
      billingStatus: 'Billing Status',
      claimStatus: 'Claim Status',
      appointmentDate: 'Appointment Date',
      claimReportStatus: 'Claim Report Status',
      filter: 'filter',
      placeholder: 'placeholder',
      date: 'Date',
      all: 'All',
      pending: 'Pending',
      reportable: 'Reportable',
      icdIssue: 'ICD Issue',
      insuranceIssue: 'Insurance Issue',
      appointmentCancelled: 'Appt. Cancelled',
      appointmentTypeIssue: 'Appt. Type Issue',
      hold: 'Hold',
      readyToBill: 'Ready for Billing',
      reported: 'Reported',
      onHold: 'On Hold',
      processing: 'Processing',
      sending: 'Sending',
      delayed: 'Delayed',
      shipped: 'Shipped',
      putOnHold: 'Put On Hold',
      revertToPending: 'Revert To Pending',
      processManually: 'Process Manually',
      cancel: 'Cancel',
      sendToPharmacy: 'Send To Pharmacy',
      delay: 'Delay',
      ship: 'Ship',
      canceled: 'Canceled',
      compounding: 'Compounding',
      dateOfBirth: 'Date of Birth',
      mmddyyyy: 'MM/DD/YYYY',
      mm: 'MM',
      dd: 'DD',
      yyyy: 'YYYY',
      claimReportHistory: 'Claim Report history',
      reportableHistory: 'Reportable history',
      ordersHistory: 'Orders history',
      claimsHistory: 'Claims history',
      assessmentsHistory: 'Assessments history',
      programsHistory: 'Programs history',
      resourcesHistory: 'Resources history',
      assessmentsAlerts: 'Assessment Alerts',
      healthSeekingBehavior: 'Help Seeking Behavior',
      items: '{{totalCount}} Items',
      searchCustomers: 'Search Customers',
      pendingReview: 'Pending Review',
      partialProcessed: 'Partial Processed',
      eTransfer: 'E-Transfer',
      noShow: 'No Show',
      noShowStatus: 'Appointment Status',
      notUpdated: 'Not Updated',
      none: 'None',
      invited: 'Invited',
      inProgress: 'In Progress',
      created: 'Created',
      scheduled: 'Scheduled',
      engaged: 'Engaged',
      completed: 'Completed',
      billingHistory: 'Billing history',
      completionRate: 'Completion Rate',
      noShowRate: 'No Show Rate',
      totalAccountsCount: 'Total Accounts Count',
      AverageDaysToPayment: 'Average Days to Payment',
      AverageUnpaidAging: 'Average Unpaid Aging',
      performanceRate: 'Performance Rate',
      assessmentName: 'Assessment name',
      procedureName: 'Procedure Name',
      completedTimestamp: 'Date Completed',
      orderedTimestamp: 'Date Ordered',
      providerFirstName: 'Provider First Name',
      providerLastName: 'Provider Last Name',
      reviewedTimestamp: 'Date Reviewed',
      draft: 'Draft',
      notCreated: 'Not Created',
      billed: 'Billed',
      inProcess: 'In Process',
      paid: 'Paid',
      denied: 'Denied',
      resubmitted: 'Resubmitted',
      notBillable: 'Not Billable',
      isp: 'ISP',
      license: 'License',
      control: 'Control',
      experimental: 'Experimental',
      imminentRisk: 'Imminent Risk',
      helpSeekingBehavior: 'Help Seeking Behavior',
      AllergyTest: 'Allergy Test',
      HomeSleepStudy: 'Home Sleep Study',
      MentalHealth: 'Mental Health',
      PainManagement: 'Pain Management',
      SleepQuality: 'Sleep Quality',
      LifestyleImprovement: 'Lifestyle Improvement',
      MentalHealthHelpRequested: 'Mental Health Help Requested',
      SleepHelpRequested: 'Sleep Help Requested',
      SleepStudyRequested: 'Sleep Study Requested',
      PainManagementHelpRequested: 'Pain Management Help Requested',
      AllergyTestRequested: 'Allergy Test Requested',
      InterestedinImmunotherapy: 'Interested in Immunotherapy',
      LifestyleHelpRequested: 'Lifestyle Help Requested',
      BHIConsent: 'BHI Consent',
      RiskFactorsIdentified: 'Risk Factors Identified',
      QNEGPositive: 'Q-NEG Positive',
      Depressionriskdetected: 'Depression risk detected',
      Anxietyriskdetected: 'Anxiety risk detected',
      PersistentPain: 'Persistent Pain',
      SignificantPhysicalLimitations: 'Significant Physical Limitations',
      ElevatedAllergyScore: 'Elevated Allergy Score',
      HighSleepDisorderRisk: 'High Sleep Disorder Risk',
      SuicideRisk: 'Suicide Risk',
      SuicideorSelfHarmRisk: 'Suicide or Self-Harm Risk',
      Psychologicaldistressnoactivesuicidalideation:
        'Psychological distress, no active suicidal ideation',
      SDoHRisk: 'SDoH Risk',
      PersonalSafetyRisk: 'Personal Safety Risk',
      PreventiveScreeningRequired: 'Preventive Screening Required',
      CheckA1C: 'Check A1C',
      Fallrisk: 'Fall risk',
      ordersOnly: 'Orders Only',
      trial: 'Trial',
      demo: 'Demo',
      other: 'Other',
      active: 'Active',
      inactive: 'Inactive',
      bhiStatus: 'BHI Status',
      Billed: 'Billed',
      NotBilled: 'Not Billed',
      Paid: 'Paid',
      PR: 'PR',
      Denied: 'Denied',
      Outstanding: 'Outstanding',
      PartiallyPaid: 'Partially Paid',
      partiallyPaid: 'Partially Paid',
      multiLineActionMode: 'Multi-line action mode',
      regularMode: 'Regular mode',
      patientResponsibility: 'Patient Responsibility',
      refreshData: 'Refresh Data',
      generateReport: 'Generate Report',
      filterSettings: 'Filter settings',
      chageStatus: 'Change status all rows of a table',
      miltiAction: 'Actions on all rows of a table',
      miltiActionAllData: 'The status change will be performed on all rows of the table at once.',
      miltiActionFilteredData:
        'The status change will be performed immediately on all table rows corresponding to the specified filters.',
      downloadOrderReports: 'Download Order Reports',
      downloadFileByFilters: 'Download File',
      downloadCSVFile: 'Download CSV File',
      downloadFileFilteredData:
        'The file will be generated from the table data corresponding to the selected filters and visible columns.',
      downloadFileAllData: 'The The file will be generated from all the data in the table.',
      numbersOfRows: 'The number of items.',
      multiLineActions: 'Multi row actions',
      totalNumberOfSelected: 'Total number of selected',
      acknowledgeDescription:
        'The status will be changed for all table values corresponding to the specified filters.',
      changeAcknowledgeStatus: 'Change status to acknowledge for all lines',
      changeStatus: 'Change Status',
      change: 'Change',
      noRecordsToDisplay: 'No records to display',
      unableToLoadData: 'Unable to load data',
      failedToLoadData: 'Failed to load data',
      unexpectedServerError: 'An unexpected server error occurred',
    },
    placeholders: {
      noColumnsSelected: 'No columns selected',
      noItemsFound: 'No {{item}} Found',
      noFilteredItemsFound:
        '{{item}} have not been authorized. \n' +
        'Contact Verdin Labs at contact@verdinlabs.com to enable {{item}} for this Account.',
      reviseFiltersOrCreateYourFirstItem: 'Revise filters or create your first {{item}}.',
      selectAtLeastOneColumn: 'Select at least one column to display the table.',
      pleaseChangeSearchText: 'Please change the search text',
      noCPTCodes: 'No CPT Codes',
      addCPTCodes: 'Add a CPT code with the {{item}} button below',
    },
    validationErrors: {
      required: 'required field',
      matchPasswords: 'passwords must match',
      invalid: 'invalid {{name}}',
      minError: '{{name}} should be at least {{length}} characters long',
      maxError: '{{name}} should be a maximum of {{length}} characters long',
      lessThan30days: 'The DOS cannot be less than 30 days before the {{date}} (Appointment Date)',
      moreThan30days: 'The DOS cannot be more than 30 days after the {{date}} (Appointment Date)',
      requiredField: '{{fieldName}}  is a required field.',
      CPTCodeRequired: 'CPT Code is a required field.',
      claimSumValueLimits: 'Value should not be less than 0 and greater than $5,000.',
      PRTypeRequired: 'PR Type is a required field if PR > 0.',
      claimStatusMustBeEqual:
        'Claim Status must be equal to Pending if Billing Status is Pending or Hold.',
      dataIsInvalid: 'Data is invalid.',
    },
    errors: {
      loadingError:
        '   Oops, there seems to have been an error loading data. Please check the link or try loading again.',
      doNotHaveAccessToAnyAccounts:
        'You do not have access to any accounts on the QHS dashboard. If you feel this is an error, contact the administrator for your QHS account.',
      unknownError: 'Your request can not be completed due to an unknown error.',
      userNotFound: 'We could not find an account for the email you provided.',
      accountIsDisabled: 'Account is disabled. \nPlease contact support at contact@verdinlabs.com.',
      credentialsInvalid: 'The email or password you entered was not valid.',
      specifiedCondition: "The specified condition was not met for 'status'.",
      validationError:
        'Some input appears to be invalid. Fix any issues indicated in red, and try again.',
      pleaseEnterDescription:
        'Please enter a description of the issue you are having. Do not remove the content under the line below',
      supportRequest: 'QHS Support Request',
      invalidData: 'Invalid Data',
      noProvidersOnThisAccount:
        'No providers on this account. At least one provider is required to create an order.',
      noLongerValid: 'This invitation is no longer valid.',
      accountOrUser: 'Account or user not found.',
      orderCouldNotFind: 'Could not find the specified account or {{name}}. Refresh and try again.',
      metadataLoadingError: 'Error Loading Data',
      metadataLoadingErrorDescription:
        'Unfortunately, we were unable to load the necessary data for creating an order. Please try refreshing the page.',
      refreshPage: 'Refresh Page',
      orderCantBeRemoved: 'The order cannot be removed, as it no longer has a status of Pending.',
      orderStatusMultiplyValidation: `The status you are trying to change for one or more {{name}}s is not
        allowed. Check the {{name}}s and try again.`,
      orderStatusSingleValidation:
        'The status you selected is not allowed based on the current status of the {{name}}.',
      patientCouldNotFind:
        'Could not find the specified account or patient. Refresh and try again.',
      patientCantBeRemoved: 'The patient {{name}} cannot be removed.',
      userCouldNotFind: 'Could not find the specified user. Refresh and try again.',
      userCantBeRemoved: 'The user profile for {{name}} cannot be removed from this account.',
      accountCouldNotFind: 'Could not find the specified account. Refresh and try again.',
      accountCantBeRemoved: 'The account {{name}} cannot be removed.',
      userProfileNotFound: 'A user profile was not found for the email specified.',
      verificationCodeInvalid:
        'The verification code is invalid. Please try again or send a new verification code.',
      tooManyInvitations:
        'Too many invitations were sent too quickly. Wait a few minutes and try again.',
      invitationCannotBeSent:
        'Invite was sent too quickly for this assessment. Try again in a minute or two.',
      invitationMessageWasJustSent:
        'Invitation message was just sent. Please try again in a few moments.',
      invitationsWereNotOriginallySent:
        'Invitations were not originally sent for this survey, so an invitation resend is not allowed.',
      dateRequiredToSend: 'The date is required to send.',
      timeRequiredToSend: 'The time is required to send.',
    },
    notifications: {
      acknowledgeStatusChanged: 'Acknowledge Status changed successfully',
      assessmentAccepted: 'Assessment accepted successfully',
      checkYourForm: 'Some fields contain errors.\n' + 'Please correct it before continuing.',
      autoLogout: 'You have been automatically logged out due to inactivity',
      logout401: 'Your Verdin Labs session has expired. Log in again to resume.',
      profileUpdated: 'Your profile updated successfully.',
      accountCreated: 'Account "{{name}}" created successfully.',
      accountEdited: 'Account "{{name}}" edited successfully.',
      claimEdited: 'Claim edited successfully.',
      accountRemoved: 'The account {{name}} has been removed.',
      userCreated: 'User "{{name}}" created successfully.',
      userEdited: 'User "{{name}}" edited successfully.',
      userRemoved: 'The user profile for {{name}} has been removed', // from {{accountName}}.',
      patientCreated: 'Patient "{{name}}" created successfully.',
      notPermissionForEditingClaim: 'You do not have permission to edit claim.',
      notPermissionForDownloadingFile: 'You do not have permission to download file.',
      surveyURLCopied: 'Assessment URL has been copied to your clipboard',
      dataCopied: 'Data has been copied to your clipboard',
      dataNotCopied: 'Data has not been copied to your clipboard',
      patientEdited: 'Patient "{{name}}" edited successfully.',
      claimEnabled: 'The claim has been successfully enabled.',
      patientRemoved: 'The patient "{{name}}" has been removed.',
      dataIsInvalid: 'Data is invalid.',
      pdfSucceededSaved: 'The pdf file downloaded successfully.',
      noShowStatusSucceededChanged: 'The "No Show" status was changed successfully.',
      noShowStatusSucceededReversed: 'The "No Show" status was reversed successfully.',
      zipSucceededSaved: 'The ZIP file downloaded successfully.',
      orderCreated: 'Order created successfully.',
      resourceCreated: 'Resource for "{{name}}" created successfully.',
      orderEdited: 'Order for "{{name}}" edited successfully.',
      orderRemoved: 'The order has been removed.',
      orderStatusChanged: '"{{name}}" status(es) changed successfully.',
      verifyCodeHasBeenSent: 'Verify code has been sent.',
      passwordHasBeenChanged: 'Password has been changed.',
      addProvider: 'Add at least one provider to the account before creating orders.',
      youHaveBeenSwitched: `You've been automatically switched to account {{name}}`,
      welcomeToQHS: 'Your password has been set. Welcome to QHS!',
      emailInvitation: 'Another email invitation has been sent.',
      assessmentCreated: 'Assessment Created',
      assessmentMustBeCompleted:
        'The patient must complete the assessment before viewing the report',
      invitationResent: 'Invitation resent successfully',
      copyToClipboard: 'The text was successfully copied to the clipboard',
      notPermissionForDeletingOrder:
        'Oops! we’re sorry, but your ability to Delete Orders has been suspended or not yet enabled in your Account. Please contact Verdin Labs customer service at contact@verdinlabs.com to request this feature be activated.',
      notPermissionForEditingOrder:
        'Oops! we’re sorry, but your ability to Edit Orders has been suspended or not yet enabled in your Account. Please contact Verdin Labs customer service at contact@verdinlabs.com to request this feature be activated.',
      notPermissionForCreatingOrder:
        'Oops! we’re sorry, but your ability to Create Orders has been suspended or not yet enabled in your Account. Please contact Verdin Labs customer service at contact@verdinlabs.com to request this feature be activated.',
      notPermissionForCreatingProgram:
        'Oops! we’re sorry, but your ability to Create Program has been suspended or not yet enabled in your Account. Please contact Verdin Labs customer service at contact@verdinlabs.com to request this feature be activated.',
      notPermissionForChangeClaimReportStatus:
        'Oops! we’re sorry, but your ability to Change Claim Report Status has been suspended or not yet enabled in your Account. Please contact Verdin Labs customer service at contact@verdinlabs.com to request this feature be activated.',
      notPermissionForCreatingAssessment:
        'Oops! we’re sorry, but your ability to Create Assessments has been suspended or not yet enabled in your Account. Please contact Verdin Labs customer service at contact@verdinlabs.com to request this feature be activated.',
      hasDrugAllergies:
        'This patient’s currently has unknown drug allergies. Update the patient record to create orders.',
      pleaseLogIn: 'Please log in to view the requested resource',
      noPermissions: 'You do not have permission to this resource',
    },
    dialogs: {
      backTo: 'back to {{title}}',
      canUseForSeveralAccounts:
        'This action is available for lines belonging to one account. Please set the appropriate filter.',
      confirmRemove: 'Confirm {{name}} Remove',
      confirmStatusChange: 'Confirm Status Change',
      generateClaimsReport: 'Generate Claims Report',
      additionalOptions: 'Additional Options',
      downloadXlsxFile: 'Download XLSX File (optional)',
      confirmResendInvitation: 'Confirm Resend Invitation',
      reportHasBeenGenerated:
        'Report has been generated. You can view/download it from the Claim Reports screen.',
      generateClaimsReportDescription1:
        'A claims report will be generated for the items you selected. Here is a summary of the claim items. To generate the report, verify everything looks correct and select ',
      generateClaimsReportDescription2: 'Verify and Generate ',
      generateClaimsReportDescription3: 'below.',
      statusDescriptionForOneOption: 'Change status to "{{status}}" for the current row?',
      statusDescription:
        'Change status to "{{status}}" for all selected rows or only the current row?',
      prescriberDeclaration: 'Prescriber Declaration',
      bySavingThisPrescription: `By saving this prescription, I state that:`,
      requirementA: `a) I am or was treating this patient for the indicated diagnosis on the
      effective date of this order;`,
      requirementB: `b) This order accurately reflects this patient’s diagnosis and condition
      and is substantiated by my medical records;`,
      requirementC: `c) I will make the original signed copy of this document a part of this
      patient’s medical records and make it available to Medicare, Medicaid and other insurers
      or any authorized agent if requested.`,
      prescribingPhysician:
        'prescribing physician has approved this order to be sent to the pharmacy',
      hipaaAgreement: 'HIPAA Business Associate Agreement',
      hipaaAgreementFor: 'HIPAA Business Associate Agreement for {{accountName}}',
      privacyFor: 'Privacy for {{accountName}}',
      hippa_baa_For: 'HIPPA BAA for {{accountName}}',
      termsFor: 'Terms for {{accountName}}',
      scrollToTheBottom: 'Scroll to the bottom to accept agreement',
      readAndAccept: 'I have read and accept the agreement',
      administratorMustAccept: `An administrator must accept the HIPPA Business Associate
      Agreement before the account can be accessed.`,
      sessionTimeout: 'Session Timeout',
      inactivityWarning: `You're being timed out due to inactivity. Please choose to stay
      signed in or to logout. Otherwise, you will be logged out automatically.`,
      createAssessmentDescription:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh.',
      updateRequired: 'Update Required',
      chooseProviders: 'Choose Providers',
      updateVersionSubtitle:
        'There is a newer version of this dashboard available. To be sure you don’t run into any problems, click Update below to load the new version.',
      newVersion: 'Update to Version ',
      skipNow: 'Skip for now',
    },
    scit: {
      buildUp46: '46 Dose/ Unit Build Up',
      buildUp50: '50 Dose/Unit Build-up',
      stage1: '10 Dose/ Unit Stage 1',
      stage2: '10 Dose/ Unit Stage 2',
      stage3: '10 Dose/ Unit Stage 3',
      stage4: '10 Dose/ Unit Stage 4',
      scitMaintenance: '12 Dose/ Unit SCIT Maintenance',
    },
    slit: {
      oneMonthLowDose: '1 Month Low Dose',
      oneMonthSLITMaintenance: '1 Month SLIT Maintenance',
    },
    allergens: {
      allergySymptomsDescription: 'List allergy symptoms',
      symptomsExposureDescription: 'Symptoms are mostly worse with exposure to',
      symptomsTimeOfYearDescription: 'Symptoms mostly occur at what time of year',
      symptomsTimeInDayDescription: 'Symptoms mostly occur at what time of day',
      symptomsMostlyOccurDescription: 'Symptoms mostly occur',
      examinationRevealsDescription: 'Examination reveals the following',
      allergyDiagnosisDescription: 'Allergy diagnosis',

      allergySymptoms: 'Patient allergy symptoms',
      symptomsExposure: 'Worse with exposure to',
      symptomsTimeOfYear: 'Seasonal occurrence',
      symptomsTimeInDay: 'Daily occurrence time',
      symptomsMostlyOccur: 'Where symptoms occur',
      examinationReveals: 'Physical exam findings',
      allergyDiagnosis: 'Clinical diagnosis',

      runnyOrStuffyNose: 'Runny or stuffy nose',
      sneezing: 'Sneezing',
      itchyNose: 'Itchy nose',
      blockedNose: 'Blocked nose',
      postNasalDripDrainage: 'Post nasal drip / drainage',
      mouthBreathingSnoring: 'Mouth breathing / snoring',
      frequentSniffling: 'Frequent sniffling',
      decreasedSmell: 'Decreased smell',
      headaches: 'Headaches',
      facialPressurePain: 'Facial pressure / pain',
      redEyes: 'Red eyes',
      itchyEyes: 'Itchy eyes',
      wateryEyes: 'Watery eyes',
      darkCircles: 'Dark circles',
      swollenDryEyes: 'Swollen dry eyes',
      soreEyes: 'Sore eyes',
      rash: 'Rash',
      hives: 'Hives',
      eczema: 'Eczema',
      swelling: 'Swelling',
      itchySkin: 'Itchy skin',
      wheezing: 'Wheezing',
      coughing: 'Coughing',
      chestTightness: 'Chest tightness',
      shortnessOfBreath: 'Shortness of Breath',
      chronicBronchitis: 'Chronic Bronchitis',
      itchyThroat: 'Itchy throat',
      throatClearing: 'Throat clearing',
      soreThroat: 'Sore throat',
      excessivePhlegm: 'Excessive phlegm',
      hoarseness: 'Hoarseness (weak, scratchy or husky voice)',

      grasses: 'Grasses',
      otherPollen: 'Other pollen',
      otherAnimalsOrInsects: 'Other animals or insects',
      dust: 'Dust',
      wind: 'Wind',
      perfume: 'Perfume',
      smokePollution: 'Smoke / pollution',
      cleaningProducts: 'Cleaning products',
      certainTypesOfFood: 'Certain types of food',
      grassesGrassMix:
        'Grass Mix (Timothy, Orchard, June, Red Top, Meadow Fescue, Perennial Rye, Sweet Venal)',
      grassesBermuda: 'Bermuda',
      grassesJohnson: 'Johnson',
      weeds: 'Weeds',
      weedsRagweed: 'Ragweed (Short ragweed, Giant/Tall Ragweed, Sagebrush)',
      weedsMugwort: 'Mugwort',
      weedsCocklbur: 'Cocklbur',
      weedsRoughMarshelder: 'Rough Marshelder',
      weedsPigweed: 'Pigweed (Rough Pigweed, Carelessweed, Western Water Hemp)',
      weedsDockSorrell: 'Dock Sorrell (Yellow Dock, Sheep Sorrel)',
      weedsChenopod: 'Chenopod (Kochia, Russian Thistle, Lambs Quarters)',
      weedsEnglishPlaintain: 'English Plantain',
      trees: 'Trees',
      treesBirch: 'Birch (Birch, Alder, Hazel)',
      treesCypress: 'Cypress (Juniper, Cedar, Cypress)',
      treesOlive: 'Olive (Olive, Ash, Privet)',
      treesBeechOak: 'Beech-Oak (Beech, Oak, Chestnut)',
      treesPecanHickory: 'Pecan-Hickory',
      treesPolarAspenCottonwood: 'Poplar-Aspen-Cottonwood',
      treesMapleElder: 'Maple-Elder',
      treesSycamore: 'Sycamore',
      treesElm: 'Elm',
      cat: 'Cat',
      dog: 'Dog',
      dustMites: 'Dust Mites',
      cockroach: 'Cockroach',
      mold: 'Mold',

      allYearRound: 'All year round',
      spring: 'Spring',
      summer: 'Summer',
      fall: 'Fall',
      winter: 'Winter',
      theyJustStarted: 'They just started',

      atNight: 'At night',
      duringTheDay: 'During the day',
      bothNightAndDay: 'Both night and day',

      indoor: 'Indoor',
      outdoor: 'Outdoor',
      bothIndoorAndOutdoor: 'Both indoor and outdoor',

      allergicRhinitis: 'Allergic rhinitis',
      asthma: 'Asthma',
      allergicConjunctivitis: 'Allergic conjunctivitis',
      atopicDermatitis: 'Atopic dermatitis',

      nasalAndSinusFindings: 'Nasal and Sinus Findings:',
      rhinorrhea: 'Rhinorrhea – Runny nose',
      nasalCongestion: 'Nasal congestion – Stuffy nose',
      turbinateHypertrophy: 'Turbinate hypertrophy – Enlarged nasal turbinates',
      septalDeviation: 'Septal deviation – Deviation of the nasal septum',
      postnasalDrip: 'Postnasal drip – Mucous drainage visible in the posterior pharynx',
      mouthBreathing: 'Mouth breathing – Observed during respiration',
      anosmiaOrHyposmia: 'Anosmia or hyposmia – Loss or decreased sense of smell',
      sinusTenderness: 'Sinus tenderness – Pain on palpation of sinuses',
      facialErythemaOrSwelling: 'Facial erythema or swelling – Inflammation around sinuses',
      boggyNasalMucosa:
        'Boggy nasal mucosa – Swollen mucosa indicative of allergies or inflammation',
      eyeFindings: 'Eye Findings:',
      conjunctivalInjection: 'Conjunctival injection – Red eyes',
      periorbitalEdema: 'Periorbital edema – Swelling around the eyes',
      darkCirclesUnderEyes: 'Dark circles under eyes (Allergic shiners)',
      conjunctivalChemosis: 'Conjunctival chemosis – Swelling of the conjunctiva',
      blepharitis: 'Blepharitis – Eyelid inflammation',
      wateryEyesExcessiveLacrimation: 'Watery eyes – Excessive lacrimation',
      allergicConjunctivitisItchy: 'Allergic conjunctivitis – Itchy, red, and watery eyes',
      dermatologicalFindings: 'Dermatological Findings:',
      erythematousRash: 'Erythematous rash – Red skin rash',
      urticaria: 'Urticaria – Hives',
      lichenifiedPlaques: 'Lichenified plaques – Seen in chronic eczema',
      xerosis: 'Xerosis – Dry skin',
      angioedema: 'Angioedema – Swelling of subcutaneous tissues',
      pruritus: 'Pruritus – Generalized itchy skin',
      respiratoryFindings: 'Respiratory Findings:',
      wheezingHighPitched: 'Wheezing – High-pitched whistling sounds on auscultation',
      prolongedExpiratoryPhase:
        'Prolonged expiratory phase – Seen in asthma or obstructive airway diseases',
      cracklesOrRales:
        'Crackles or rales – Fine or coarse sounds on auscultation (if coexisting conditions)',
      rhonchi: 'Rhonchi – Low-pitched sounds from airway congestion',
      decreasedBreathSounds:
        'Decreased breath sounds – Indicative of airway obstruction or hyperinflation',
      coughingProductive: 'Coughing – Productive or nonproductive, audible during examination',
      barrelChest: 'Barrel chest – Chronic bronchitis-related physical finding',
      intercostalRetractions: 'Intercostal retractions – Seen in severe respiratory distress',
      throatFindings: 'Throat Findings:',
      pharyngealErythema: 'Pharyngeal erythema – Red throat',
      cobblestoningOfThePosteriorPharynx:
        'Cobblestoning of the posterior pharynx – Mucosal thickening due to postnasal drip',
      hoarsenessObserved: 'Hoarseness – Observed during conversation or phonation',
      tonsillarHypertrophy: 'Tonsillar hypertrophy – Enlarged tonsils',
      lymphadenopathy: 'Lymphadenopathy – Enlarged lymph nodes, typically cervical',
      throatClearingObserved: 'Throat clearing – Observed habit during examination',
    },
    formulas: {
      outdoor: 'Outdoor',
      indoor2: 'Indoor 2',
      indoor3: 'Indoor 3',
      indoor4: 'Indoor 4',
      mold: 'Mold',
      environment: 'Environment',
    },
    ordersCsv: {
      organization: 'Organization',
      firstName: 'First Name',
      lastName: 'Last Name',
      dob: 'DOB',
      gender: 'Gender',
      allergies: 'Allergies',
      patientPhone: 'Patient Phone',
      patientAddress: 'Patient Address',
      clinician: 'Clinician',
      npi: 'NPI',
      shipTo: 'Ship To',
      accountCustomIdentifier: 'Custom ID',
      category: 'Category',
      type: 'Type',
      formula: 'Formula',
      qty: 'Qty',
      geography: 'Geography',
      date: 'Date',
      comments: 'Comments',
    },
    allergyBaselineAssessmentReport: {
      title: 'Allergy Baseline Assessment Report',
      firstPart: `The Verdin Labs ‘Allergy Assessment’ is a proprietary digital medicine tool developed to assist clinicians identify and deal with common allergic conditions, allergen triggers, symptom severity, medication use and frequency and health habits. The Allergy Assessment agrees with the definition for using CPT code 96160, “Administration of patient-focused health risk assessment instrument (e.g., health hazard appraisal) with scoring and documentation, per standardized instrument.`,
      requirementsFirst: 'The requirements to report 96160 are as follows:',
      requirementsSecond:
        'Practice expense is incurred to administer the instrument (such as nurse time or for purchase of the screen).\n' +
        'The instrument is standardized.\n' +
        'The instrument is scorable.\n' +
        'The results are documented in the medical record.',
      requirementsThird:
        'The term “standardized” means previously validated tests that are administered and scored in a consistent or “standard” manner.',
      requirementsForth:
        'What constitutes “scoring.” This is an important distinction between a true health risk assessment and history gathering forms. The instrument, at a minimum, should provide a threshold result or pertinent yes/no responses that would indicate a patient’s risk for an adverse health outcome or risk for further exacerbation of a current, typically chronic, medical condition.',
      QHSLabAllergyAssessmentTitle: 'Verdin Labs Allergy Assessment',
      QHSLabAllergyAssessmentText:
        'The Allergy Assessment is a proprietary digital medicine application that combines several validated and standardized allergy and asthma-related instruments described below. This assessment includes patient responses and scoring related to their allergy history, recent allergy and asthma symptoms, environmental impact and severity of these symptoms, allergy and asthma medication use, and lifestyle behaviors. The Allergy Assessment was developed to help physicians and other healthcare providers in their routine evaluation of patients suspected to have allergies and comorbid asthma. "Digital Medicine" is a term that relates to computerized applications that are directed by physicians and other healthcare providers. This assessment is not meant to be diagnostic or therapeutic, but to be used as an adjunct to clinical decision making. \n',
      respiratoryAllergyPredictionTestTitle: 'Respiratory Allergy Prediction Test',
      respiratoryAllergyPredictionTestText:
        'The Respiratory Allergy Prediction Test is a validated and straightforward four item assessment. This is designed to confirm the clinical suspicion of respiratory allergy and the medical necessity of performing allergy testing by its high predictive value. Answering yes to the following three questions: 1) occurrence of symptoms in the springtime, 2) to have or have had a cough and shortness of breath, and 3) to frequent use of nasal sprays, provides a high probability (85%) of a respiratory allergy diagnosis. It also suggests a real need for allergy testing to confirm the allergen trigger. If a patient answered yes to the questions just described. In that case, the physicians digital interpretation report will indicate the patient is highly likely to test positive to an allergy blood or skin test for confirmation of the environmental allergen triggers (Galimberti et al., 2015). ',
      generalAllergyHistoryTitle: 'General Allergy History',
      generalAllergyHistoryText:
        'A patient\'s knowledge of their various health conditions, or "health literacy," has been shown to benefit their approach to self-management and overall quality of life. Suppose a patient answers that they do not know if they have a health condition such as Allergic Rhinitis, Asthma, Allergic Conjunctivitis, or Allergic Urticaria. This situation could provide an educational opportunity to explain the condition, determine if the patient is suffering from the condition, and explain proper management of the condition. If a patient answers that they have the condition and treated in the past, this will provide insight into their expectation of the current treatment to be proposed. Both of these responses are opportunities to reinforce evidence-based approaches to allergy management.',
      patientReportedAllergySymptomsTitle: 'Patient Reported Allergy Symptoms',
      patientReportedAllergySymptomsText:
        "Allergens that cause symptoms can be broadly categorized as predominantly outdoor, indoor, or food-related. Different outdoor allergens pollinate at various times during the year. Trees produce pollen in the early to mid-springtime, grass pollination occurs later in spring through summer, and weeds pollinate in the fall season. Outdoor mold spores can also affect allergy sufferers year round when conditions suit fungi or mold growth, such as after the winter frost melts in early spring or after heavy rain periods followed by warmer weather conditions. Perennial allergens, such as dust mites, animal dander, insects, and mold allergens, which are likely to be found indoors in areas with high moisture or humidity conditions are very prevalent year round allergy symptom triggers. A patient's responses to questions regarding symptoms, occurrence, and environment help physicians determine the likely allergen to be affecting the patient, to be confirmed through a skin or blood test, and also helps the physician prescribe or modify medications.",
      sinoNasalOutcomeTestTitle: 'Sino-Nasal Outcome Test-22 (SNOT-22)',
      sinoNasalOutcomeTestText1:
        "The Sino-Nasal Outcome Test-22 (SNOT-22) is a commonly utilized disease-specific questionnaire involving 22 symptoms that combine rhinologic issues with general health issues. The SNOT-22 has been validated and has been proven easy to use throughout the world in clinical practice and research. Physicians can use this test to facilitate routine clinical practice to highlight chronic rhinosinusitis's impact on patients' quality of life. This test is also frequently used to measure the outcome of surgical intervention and specific allergen immunotherapy treatment (Hopkins et al., 2009).",
      sinoNasalOutcomeTestText2:
        "You will find the patient's overall result of their SNOT-22 (reported in the section titled Physician Interpretation) with one of the following indications:",
      sinoNasalOutcomeTestText3:
        'Physicians can review each of the 22 answers to the SNOT-22 in the report section under the heading "Allergy Symptom Severity SNOT-22."',
      sinoNasalOutcomeTestMildTitle: 'Mild',
      sinoNasalOutcomeTestMildText: 'Score of 8-19',
      sinoNasalOutcomeTestModerateTitle: 'Moderate',
      sinoNasalOutcomeTestModerateText: 'Score between 20-50',
      sinoNasalOutcomeTestSevereTitle: 'Severe',
      sinoNasalOutcomeTestSevereText: 'Score greater than 50',
      asthmaControlTestTitle: 'Asthma Control Test (ACT)',
      asthmaControlTestText:
        "Chronic Rhinosinusitis (CRS) is strongly associated with comorbid asthma. The Asthma Control Test (ACT) quickly provides a numerical score to assess asthma control. The ACT is recognized by the National Institutes of Health (NIH) in its 2007 asthma guidelines and has been clinically validated against spirometry and specialist assessment (Nathan et al. 2004). Suppose your patient indicates that they have asthma in the general allergy history section. In that case, you will find the overall score to how well the patients asthma is under control from the ACT reported in the Physician Interpretation section. A score of 19 or less indicates that the patient's asthma might not be under control.",
      allergyMedicationUseTitle: 'Allergy Medication Use',
      allergyMedicationUseText:
        'Patients are often self-diagnosing and self-medicating inappropriately. The most commonly devised strategies for allergy symptoms are related to adherence to medications. Patients who self-medicate with OTC medications are likely to suffer from poor adherence rates, incorrect medications may be taken without medical or pharmacist direction. Self-management strategies can be better implemented when a patient’s medication type and use has been evaluated in combination with their symptom frequency and severity and environmental encounters.  The Allergy Assessment records the patients responses to medication use and frequency of antihistamines, decongestants, cromolyn, leukotriene receptor antagonists and combination long acting and beta2-adrenergic bronchodilators for patients that indicate they are asthmatic. ',
      healthBehaviorsTitle: 'Health Behaviors',
      healthBehaviorsTextFirst:
        "It is well known that a positive lifestyle including regular physical activity, weight control, good sleep hygiene, a healthy diet rich in fruits and vegetables, not using tobacco (and eliminating exposure to second-hand smoke), and psychological well-being can help allergy sufferers. Many patients know they need to make lifestyle changes but they don't often take it seriously until they hear it from a trusted medical professional. The Allergy Assessment also presents patients with questions related to their Health Behaviors and provides physicians with the patient's scores to physical activity and exercise levels, fruits and vegetable consumption, and tobacco use, as these health behaviors have obvious impact on a patients general wellbeing, weight management, and psychosocial health including quality of sleep.",
      healthBehaviorsTextSecond:
        'When patients are asymptomatic or have their pollen triggers under control, physicians should encourage their allergy and asthma patients achieve the recommended physical activity and exercise guidelines. Also, encouraging patients to spend time outside, especially in green spaces such as parks, forests, lakes, and beaches, when possible, to attract some good "bugs" into their microbiota is also beneficial to allergic disease management. Safe exposure to direct sunlight to soak up some natural vitamin D while exercising outdoors can also be beneficial.',
      healthBehaviorsTextThird:
        'Consuming a diet high in fermentable fiber, with fruits and vegetables and regular prebiotics, is highly beneficial and includes items such as garlic, onion, leek, chicory root, and asparagus. Probiotic-rich foods are also recommended and include fermented cabbage, sauerkraut or kimchi, pickles, buttermilk, and live-cultured yogurts. A healthy diet combined with prebiotics and probiotics may aid in allergy protection for your patients (Pullen and Grogan 2017).',
      healthBehaviorsTextForth:
        'In conclusion, the Verdin Labs Allergy Assessment provides a digital medicine tool for clinicians to quickly assess a patient’s likely allergy triggers and environmental conditions that affect their symptom severity and quality of life. With this simple digital health risk assessment, clinicians can determine if further confirmatory blood or skin tests are needed and if the patient would benefit from an allergy specialist involvement and/or allergen immunotherapy treatment approach.',
      referencesTitle: 'References',
      referencesFirst:
        'Galimberti et al. Catching allergy by a simple questionnaire. World Allergy Organization Journal (2015) 8:16',
      referencesSecond:
        'Hopkins C et al. Psychometric validity of the 22-item Sinonasal Outcome Test. Clin Otolaryngol. 2009 Oct;34(5):447-54.',
      referencesThird:
        'Toma S, Hopkins C. Stratification of SNOT-22 scores into mild, moderate, or severe and relationship with other subjective instruments. Rhinology. 2016 Jun;54(2):129-33.',
      referencesFourth:
        'US Department of Health and Human Services, National Institutes of Health, National Heart, Lung, and Blood Institute. Expert Panel Report 3: Guidelines for the Diagnosis and Management of Asthma (EPR-3 2007). ',
      referencesFifth: 'Nathan RA et al. J Allergy Clin Immunol. 2004;113:59-65.',
      referencesSixth:
        'Pullen and Grogan. Allergies on the Rise Solutions from Primary care. MedScience Research Group, Inc. (2017).',
    },
    QScaleReport: {
      title: 'Q-Scale',
      subtitle: 'Stress Type Test & Kessler 6 Instruments',
      firstPart:
        'A major advancement in psychological research and epidemiology over the last 40 years has been the development of lay-administered structured interviews, allowing the standardized estimation of the prevalence of psychological disorders among non-clinical populations.',
      secondPart:
        '"Q" stands for “Quality of Life,” and the Q-Scale measures a patient\'s responses or early warning signs to questions about their sleep, stress, anxiety, worry, pain and satisfaction. Verdin Labs created the Q-Scale instrument to generate information on psychosocial wellbeing in otherwise healthy patients. Thus, items in the Q-Scale have been deliberately written to emphasize normal psychological functioning in generally healthy patients. If responses to the Q-Scale indicate potential mental health troubles, patients are directed to the Stress Type Test and Kessler 6 questions to identify their risk of clinical anxiety and depression for further clinical evaluation.',
      thirdPart:
        'Some people manage their stress best physically (running, playing sports, going to the gym), and others do it best mentally (meditation, relaxation, cognitive behavioral therapy). Patients who screen positively to questions relating to "feeling under strain pressure" or "finding it difficult to relax\' are directed to the Stress Type Test. The Stress Type Test is a 14 item assessment that identifies how the patient may best respond to a physical or cognitive stress management approach.¹',
      fourthPart:
        "The Kessler Screening Scale for Psychological Distress (Kessler 6) has been used widely as a screener for mental health problems and to measure the severity of the impact of mental health problems on a patient's daily life. The Kessler 6 is an appropriate screening and severity measure for mood disorders. It also predicts health-related quality of life over and above that predicted by diagnoses alone. Respondents rate how often they felt nervous, hopeless, restless, or fidgety, so sad that nothing could cheer them up, that everything was an effort, and worthless.²",
      referencesTitle: 'References',
      referencesFirst:
        'Egger, Binns, Rossner, & Sagner. (2017) Lifestyle Medicine. Lifestyle, the Environment and Preventive Medicine in Health and Disease. Third Edition. Academic Press',
      referencesSecond:
        'Kessler RC, Andrews G, Colpe LJ, Hiripi E, Mroczek DK, Normand SL, Walters EE, Zaslavsky AM Psychol Med. 2002 Aug; 32(6):959-76',
    },
    pediatricAllergyBaselineAssessmentReport: {
      title: 'Pediatric Allergy Baseline Assessment Report',
      firstPart: `The Verdin Labs ‘Pediatric Allergy Assessment’ is a proprietary digital medicine tool developed to assist clinicians identify and deal with common allergic conditions, allergen triggers, symptom severity, medication use and frequency in children. The Pediatric Allergy Assessment agrees with the definition for using CPT code 96160, “Administration of patient-focused health risk assessment instrument (e.g., health hazard appraisal) with scoring and documentation, per standardized instrument.`,
      requirementsFirst: 'The requirements to report 96160 are as follows',
      requirementsSecond:
        'Practice expense is incurred to administer the instrument (such as nurse time or for purchase of the screen). The instrument is standardized. The instrument is scorable. The results are documented in the medical record.',
      requirementsThird:
        'The term “standardized” means previously validated tests that are administered and scored in a consistent or “standard” manner.',
      requirementsForth:
        'What constitutes “scoring.” This is an important distinction between a true health risk assessment and history gathering forms. The instrument, at a minimum, should provide a threshold result or pertinent yes/no responses that would indicate a patient’s risk for an adverse health outcome or risk for further exacerbation of a current, typically chronic, medical condition.',
      QHSLabAllergyAssessmentTitle: 'Verdin Labs Pediatric Allergy Assessment',
      QHSLabAllergyAssessmentText:
        'The Pediatric Allergy Assessment is a proprietary digital medicine application that combines several validated and standardized allergy and asthma-related instruments described below. This assessment includes parent and guardian responses and scoring related to their child’s allergy history, recent allergy and asthma symptoms, environmental impact and severity of these symptoms, and allergy and asthma medication use. The Pediatric Allergy Assessment was developed to help physicians and other healthcare providers in their routine evaluation of children suspected to have allergies and comorbid asthma. "Digital Medicine" is a term that relates to computerized applications that are directed by physicians and other healthcare providers. This assessment is not meant to be diagnostic or therapeutic, but to be used as an adjunct to clinical decision making.',
      respiratoryAllergyPredictionTestTitle: 'Respiratory Allergy Prediction Test',
      respiratoryAllergyPredictionTestText:
        'The Respiratory Allergy Prediction Test is a validated and straightforward four item assessment. This is designed to confirm the clinical suspicion of respiratory allergy and the medical necessity of performing allergy testing by its high predictive value. Answering yes to the following three questions: 1) occurrence of symptoms in the springtime, 2) to have or have had a cough, wheezing and shortness of breath, and 3) to frequent use of nasal sprays, provides a high probability (85%) of a respiratory allergy diagnosis. It also suggests a real need for allergy testing to confirm the allergen trigger. If a patient answered yes to the questions just described. In that case, the physicians digital interpretation report will indicate the patient is highly likely to test positive to an allergy blood or skin test for confirmation of the environmental allergen triggers (Galimberti et al., 2015 & Sacchetti M et al).',
      generalAllergyHistoryTitle: 'General Allergy History',
      generalAllergyHistoryText:
        'A parent or guardians knowledge of their child’s various health conditions, or "health literacy," has been shown to benefit their approach to self-management and overall quality of life. Suppose a parent or guardian answers that they do not know if their child has a health condition such as Allergic Rhinitis, Asthma, Allergic Conjunctivitis, Allergic Urticaria, food allergy or anaphylaxis. This situation could provide an educational opportunity to explain the condition, determine if the child is suffering from the condition, and explain proper management of the condition. If a parent or guardian answers that their child has the condition and treated in the past, this will provide insight into their expectation of the current treatment to be proposed. Both of these responses are opportunities to reinforce evidence-based approaches to allergy management.',
      patientReportedAllergySymptomsTitle: 'Parent or Guardian Reported Child’s Allergy Symptoms',
      patientReportedAllergySymptomsText:
        'Allergens that cause symptoms can be broadly categorized as predominantly outdoor, indoor, or food-related. Different outdoor allergens pollinate at various times during the year. Trees produce pollen in the early to mid-springtime, grass pollination occurs later in spring through summer, and weeds pollinate in the fall season. Outdoor mold spores can also affect allergy sufferers year round when conditions suit fungi or mold growth, such as after the winter frost melts in early spring or after heavy rain periods followed by warmer weather conditions. Perennial allergens, such as dust mites, animal dander, insects, and mold allergens, which are likely to be found indoors in areas with high moisture or humidity conditions are very prevalent year round allergy symptom triggers. A parent or guardian’s responses to questions regarding their child’s symptoms, occurrence, and environment help physicians determine the likely allergen to be affecting the child, to be confirmed through a skin or blood test, and also helps the physician prescribe or modify medications.',
      sinoNasalOutcomeTestTitle: 'Sino-Nasal Outcome Test-22 (SNOT-22)',
      sinoNasalOutcomeTestText1:
        "The Sino-Nasal Outcome Test-22 (SNOT-22) is a commonly utilized disease-specific questionnaire involving 22 symptoms that combine rhinologic issues with general health issues. The SNOT-22 has been validated and has been proven easy to use throughout the world in clinical practice and research. Physicians can use this test to facilitate routine clinical practice to highlight chronic rhinosinusitis's impact on patients' quality of life. This test is also frequently used to measure the outcome of surgical intervention and specific allergen immunotherapy treatment (Hopkins et al., 2009).",
      sinoNasalOutcomeTestText2:
        "You will find the patient's overall result of their SNOT-22 (reported in the section titled Physician Interpretation) with one of the following indications:",
      sinoNasalOutcomeTestText3:
        'Physicians can review each of the 22 answers to the SNOT-22 in the report section under the heading "Allergy Symptom Severity SNOT-22."',
      sinoNasalOutcomeTestMildTitle: 'Mild',
      sinoNasalOutcomeTestMildText: 'Score of 8-19',
      sinoNasalOutcomeTestModerateTitle: 'Moderate',
      sinoNasalOutcomeTestModerateText: 'Score between 20-50',
      sinoNasalOutcomeTestSevereTitle: 'Severe',
      sinoNasalOutcomeTestSevereText: 'Score greater than 50',
      asthmaControlTestTitle: 'Asthma Control Test (ACT)',
      asthmaControlTestText:
        "Chronic Rhinosinusitis (CRS) is strongly associated with comorbid asthma. The Asthma Control Test (ACT) quickly provides a numerical score to assess asthma control. The ACT is recognized by the National Institutes of Health (NIH) in its 2007 asthma guidelines and has been clinically validated against spirometry and specialist assessment (Nathan et al. 2004). Suppose your patient indicates that they have asthma in the general allergy history section. In that case, you will find the overall score to how well the patients asthma is under control from the ACT reported in the Physician Interpretation section. A score of 19 or less indicates that the patient's asthma might not be under control.",
      allergyMedicationUseTitle: 'Allergy Medication Use',
      allergyMedicationUseText:
        'Parents and guardians are often self-diagnosing and self-medicating their children inappropriately. The most commonly devised strategies for allergy symptoms are related to adherence to medications. Patients who self-medicate with OTC medications are likely to suffer from poor adherence rates, incorrect medications may be taken without medical or pharmacist direction. Self-management strategies can be better implemented when a patient’s medication type and use has been evaluated in combination with their symptom frequency and severity and environmental encounters. The Pediatric Allergy Assessment records the parent or guardians responses to their child’s medication use and frequency of antihistamines, decongestants, cromolyn, leukotriene receptor antagonists and combination long acting and beta2-adrenergic bronchodilators for patients that indicate they are asthmatic. \n In conclusion, the Verdin Labs Pediatric Allergy Assessment provides a digital medicine tool for clinicians to quickly assess a patient’s likely allergy triggers and environmental conditions that affect their symptom severity and quality of life. With this simple digital health risk assessment, clinicians can determine if further confirmatory blood or skin tests are needed and if the patient would benefit from an allergy specialist involvement and/or allergen immunotherapy treatment approach.',
      referencesTitle: 'References',
      referencesFirst:
        'Galimberti et al. Catching allergy by a simple questionnaire. World Allergy Organization Journal (2015) 8:16',
      referencesSecond:
        'Sacchetti M et al. Development and preliminary validation of a new screening questionnaire for identifying atopic children. Pediatric Health, Medicine and Therapeutics 2017:8 99–105',
      referencesThird:
        'Hopkins C et al. Psychometric validity of the 22-item Sinonasal Outcome Test. Clin Otolaryngol. 2009 Oct;34(5):447-54.',
      referencesFourth:
        'Toma S, Hopkins C. Stratification of SNOT-22 scores into mild, moderate, or severe and relationship with other subjective instruments. Rhinology. 2016 Jun;54(2):129-33.',
      referencesFifth:
        'US Department of Health and Human Services, National Institutes of Health, National Heart, Lung, and Blood Institute. Expert Panel Report 3: Guidelines for the Diagnosis and Management of Asthma (EPR-3 2007).',
      referencesSixth: 'Nathan RA et al. J Allergy Clin Immunol. 2004;113:59-65.',
    },
    SNOT22Report: {
      title: 'SNOT-22 Assessment',
      firstPart: `SNOT-22 is a disease-specific questionnaire involving 22 symptoms that combine rhinologic issues with general health issues, which provides an overall symptom severity score that may be impacting a patients quality of life.`,
      sinoNasalOutcomeTestTitle: 'Sino-Nasal Outcome Test-22 (SNOT-22)',
      sinoNasalOutcomeTestText1:
        "The Sino-Nasal Outcome Test-22 (SNOT-22) is a commonly utilized disease-specific questionnaire involving 22 symptoms that combine rhinologic issues with general health issues. The SNOT-22 has been validated and has been proven easy to use throughout the world in clinical practice and research. Physicians can use this test to facilitate routine clinical practice to highlight chronic rhinosinusitis's impact on patients' quality of life. This test is also frequently used to measure the outcome of surgical intervention and specific allergen immunotherapy treatment (Hopkins et al., 2009).",
      sinoNasalOutcomeTestText2:
        "You will find the patient's overall result of their SNOT-22 (reported in the section titled Physician Interpretation) with one of the following indications:",
      sinoNasalOutcomeTestText3:
        'Physicians can review each of the 22 answers to the SNOT-22 in the report section under the heading "Allergy Symptom Severity SNOT-22."',
      sinoNasalOutcomeTestMildTitle: 'Mild',
      sinoNasalOutcomeTestMildText: 'Score of 8-19',
      sinoNasalOutcomeTestModerateTitle: 'Moderate',
      sinoNasalOutcomeTestModerateText: 'Score between 20-50',
      sinoNasalOutcomeTestSevereTitle: 'Severe',
      sinoNasalOutcomeTestSevereText: 'Score greater than 50',
      referencesTitle: 'References',
      referencesFirst:
        'Hopkins C et al. Psychometric validity of the 22-item Sinonasal Outcome Test. Clin Otolaryngol. 2009 Oct;34(5):447-54.',
    },
    asthmaControlAssessmentReport: {
      title: 'Asthma Control Test (ACT)',
      firstPart: `The Asthma control test is a 5 item assessment that indicates how well a patients Asthma control has been over the past month.`,
      asthmaControlTestTitle: 'Asthma Control Test (ACT)',
      asthmaControlTestText:
        'Chronic Rhinosinusitis (CRS) is strongly associated with comorbid asthma. The Asthma Control Test (ACT) quickly provides a numerical score to assess asthma control. The ACT is recognized by the National Institutes of Health (NIH) in its 2007 asthma guidelines and has been clinically validated against spirometry and specialist assessment (Nathan et al. 2004).',
      asthmaControlTestText2:
        "A score of 19 or less indicates that the patient's asthma might not be under control.\n",
      referencesTitle: 'References',
      referencesFirst:
        'US Department of Health and Human Services, National Institutes of Health, National Heart, Lung, and Blood Institute. Expert Panel Report 3: Guidelines for the Diagnosis and Management of Asthma (EPR-3 2007).',
      referencesSecond: 'Nathan RA et al. J Allergy Clin Immunol. 2004;113:59-65.',
    },
    printReport: {
      assessmentDate: 'Assessment Date',
      dateOfBirth: 'Date of Birth',
      sex: 'Sex',
      male: 'Male',
      female: 'Female',
      MRN: 'MRN',
      zipCode: 'Zip code',
      providerName: 'Provider Name',
      providerNPI: 'Provider NPI',
      accountAddress: 'Account Address',
    },
    printBilling: {
      billingReport: 'Billing Report',
      procedureName: 'Procedure Name',
      procedureDescription: 'Procedure Description',
      exampleCPT: 'Example CPT',
      completedTimestamp: 'Date Completed',
      reviewedTimestamp: 'Provider Review Date',
      dateOfBirth: 'Date of Birth',
      sex: 'Sex',
      male: 'Male',
      female: 'Female',
      MRN: 'MRN',
      zipCode: 'Zip code',
      providerName: 'Provider Name',
      accountAddress: 'Account Address',
    },
    charts: {
      '< 1': '< 1',
      '1-4': '1-4',
      '5-14': '5-14',
      '15-24': '15-24',
      '25-34': '25-34',
      '35-44': '35-44',
      '45-54': '45-54',
      '55-64': '55-64',
      '65-74': '65-74',
      '75-84': '75-84',
      '> 84': '> 84',
      genderFemale: 'Gender (Female)',
      averageAge: 'Average age',
      generalHealth: 'General Health',
      symptomSeveritySnot22: 'Symptom Severity (SNOT-22)',
      physicalActivity: 'Physical Activity',
      fruitVegetableConsumption: 'Fruit and Vegetable Consumption',
      tobaccoUse: 'Tobacco Use',
      ageRange: 'Age Range',
      asthma: 'Asthma',
      allergicRhinitis: 'Allergic Rhinitis',
      allergicUrticara: 'Allergic Urticara',
      allergicConjunctivitis: 'Allergic Conjunctivitis',
      numberOfPatients: 'Number of patients',
      good: 'Good',
      fair: 'Fair',
      very_good: 'Very Good',
      excellent: 'Excellent',
      poor: 'Poor',
      do_not_know: 'I do not know if I have this condition',
      know_i_dont_have: 'I know I do not have this condition',
      never_treated: 'I have this condition but never treated for it',
      treated_in_past: 'I have this condition and treated in the past',
      treated_monitored: 'I am treated and monitored regulary for this condition',
      low: 'Low',
      lowRisk: 'Low Risk',
      moderate: 'Moderate',
      moderateRisk: 'Moderate Risk',
      highRisk: 'High Risk',
      mild: 'Mild',
      severe: 'Severe',
    },
    fileUploading: {
      dragFileHere: 'DRAG FILE HERE OR',
      availableFormats: '* available file format - ".XLSX"',
      fileIsUploaded: 'The file is uploaded and validated...',
      fileSuccessfullyValidated: 'File successfully validated',
      importPatientsNow: 'Import Now',
      importInsuranceNow: 'Import Insurance Now',
      fileTypeNotSupported: 'File type not supported',
      downloadValidationErrors: 'download validation errors',
      fileHasValidationErrors: 'Uploaded file has validation errors',
      uploadAndValidate: 'Upload And Validate',
      selectFile: 'Select File',
      uploadOneFile: 'Please upload one file',
      importWasSuccessful: 'Import was successful',
      ok: 'ok',
      error500:
        "The string 'United States' was not recognized as a valid DateTime. There is an unknown word starting at index '0'",
    },
    tooltips: {
      oneAccountColumnsMustBeSelected:
        'At least one of the account columns must be selected for a Distribution Sponsor.',
      enableAutomation: 'Enable Automation',
      availableOnlyForDS: 'Available only for DS account',
    },
    infoPane: {
      patient: 'Patient',
      clickToCopyToClipboard: 'Click to copy value',
      editPatient: 'Edit patient',
      openPatientDashboard: 'Open Patient Dashboard',
      sentEmail: 'Send email',
      metrics: 'Metrics',
      claims: 'Claims',
      assessments: 'Assessments',
      reportables: 'Reportables',
      resource: 'Resources',
      alerts: 'Alerts',
      emailPatient: 'Email Patient?',
      openEmailApp:
        'Choose how you would like to send an email to this patient.',
      emailPatientWithApp: 'Open in Mail App',
      emailPatientWithOutlook: 'Open in Outlook Web',
      emailHandlerNote:
        'If clicking "Open in Mail App" does nothing, your browser may not have a default email handler configured.',
      emailHandlerLink: 'How to set up',
      send: 'Send',
      filtersApplied: 'Filters Applied',
      moreDetails: 'More Details',
      clickToOpenInfoPane: 'Click to open info pane',
      info: 'Info',
      programInfo: 'Program Info',
      anonymousPatient: 'Anonymous Assessment',
      anonymousPatientInfo: 'No patient information collected',
    },
    // TEMP: Assessment Performance backport (2026-05-07).
    // Orphan after refactor/mui-v9-migration merges into development —
    // the FSD branch carries the same keys under the same path, so the
    // merge collapses to one block instead of conflicting.
    assessmentPerformance: {
      pageSubtitle: 'Compare assessment completion across two periods.',
      preset: 'Preset',
      presetWoW: 'Week over week',
      presetMoM: 'Month over month',
      periodALabel: 'Current',
      periodBLabel: 'Previous',
      periodAPlaceholder: 'Pick current period',
      periodBPlaceholder: 'Pick previous period',
      accountLabel: 'Account',
      accountsLabel: 'Accounts',
      selectAccountsPlaceholder: 'Select accounts…',
      pickAccountsPrompt: 'Select at least one account to load metrics.',
      tableSubtitle: 'Previous → Current (Δ%). Click a row to drill down.',
      exportCsv: 'Export CSV',
      emailFullReview: 'Email full review',
      previous: 'Previous',
      loading: 'Loading assessment performance…',
      errorRetry: 'Could not load metrics. Please retry in a moment.',
      emptyTitle: 'No data for the selected periods.',
      allMetrics: 'All metrics — totals across selected accounts',
      chartTitle: 'Period comparison — selected metric',
      tableTitle: 'Account-level breakdown',
      tableAccount: 'Account',
      tableTotals: 'Totals',
      metricSent: 'Sent',
      metricCombinedCompleted: 'Combined Completed',
      metricCompleted: 'Completed',
      metricETransfer: 'eTransfer',
      metricInvited: 'Invited (not started)',
      metricPartialProcessed: 'Partial Processed',
      metricInProgress: 'In Progress',
      metricPendingReview: 'Pending Review',
      metricNoShow: 'No-show',
      // Drilldown modal
      drilldownTitle: 'Account breakdown',
      drilldownActiveFilters: 'Active filters',
      drilldownMetricsBreakdown: 'Metrics breakdown',
      drilldownMetricColumn: 'Metric',
      drilldownEmailSummary: 'Email account summary',
      drilldownEmailHint: 'Opens your default mail client with the breakdown pre-filled.',
      kpiSent: 'Sent',
      kpiCompleted: 'Completed + E-T',
      kpiCompletionRate: 'Completion rate',
      close: 'Close',
    },
    populationHealth: {
      exportFile: 'Export file',
      dateRange: 'Date Range',
      assessmentType: 'Assessment Type',
      comparisonMode: 'Comparison Mode',
      baselineVsFollowup: 'Baseline vs Follow-up',
      singleTimePoint: 'Single Time Point',
      totalPatients: 'Total Patients',
      loadingPopulationHealthData: 'Loading population health data...',
      noMetricsAvailable: 'No metrics available for selected assessment instrument',
      pleaseSelectDifferentInstrument:
        'Please select a different instrument or choose "All Instruments"',
      patientDetails: 'Patient Details',
      baselinePatients: 'Baseline Patients',
      followupPatients: 'Follow-up Patients',
      populationDistribution: 'Population Distribution',
      baselineVsFollowupComparison: 'Baseline vs Follow-up Comparison',
      metricSummary: 'Metric Summary',
      totalPatientsCount: 'Total Patients',
      ofPopulation: 'Of Population',
      riskLevel: 'Risk Level',
      change: 'Change',
      patientList: 'Patient List',
      noPatients: 'No patients',
      foundForThisMetric: 'found for this metric',
      noBaselinePatients: 'No baseline patients',
      noFollowupPatients: 'No follow-up patients',
      lastAssessment: 'Last assessment',
      score: 'Score',
      low: 'Low',
      moderate: 'Moderate',
      high: 'High',
      critical: 'Critical',
      helpRequested: 'Help Requested',
      monitor: 'Monitor',
      otherPatients: 'Other Patients',
      baseline: 'Baseline',
      followup: 'Follow-up',
      baselineLight: 'Baseline (Light)',
      followupFullColor: 'Follow-up (Full Color)',
      numberOfPatients: 'Number of Patients',
      patients: 'Patients',
      clickToViewDetails: 'Click to view patient details',
      colorsIndicateRiskLevels:
        'Colors indicate risk levels: Red (Critical), Orange (High), Blue (Monitor), Green (Help Requested)',
      redCritical: 'Red (Critical)',
      orangeHigh: 'Orange (High)',
      blueMonitor: 'Blue (Monitor)',
      greenHelpRequested: 'Green (Help Requested)',
    },
    unsavedChanges: {
      title: 'Unsaved changes',
      defaultMessage: 'Your changes will be lost if you leave.',
      keepEditingButton: 'Stay',
      discardButton: 'Leave',
      // User forms
      userProfile: 'You have unsaved changes to your profile.',
      userCreate: 'You have unsaved changes to the new user.',
      userEdit: "You have unsaved changes to {name}'s profile.",
      userEditWarning:
        'Any changes you made to user information, roles, or permissions will be permanently lost and cannot be recovered.',
      // Account forms
      accountCreate: 'You have unsaved changes to the new account.',
      accountEdit: 'You have unsaved changes to {name} settings.',
      accountPermissions: 'You have unsaved changes to {name} permissions.',
      accountSwitchWarning:
        'You have unsaved changes to {name} permissions. Switching accounts will lose your changes.',
      // Order forms
      orderCreate: 'You have unsaved changes to the new order.',
      orderEdit: 'You have unsaved changes to this order.',
      // Assessment forms
      assessmentCreate: 'You have unsaved changes to the new assessment.',
      // Claim forms
      claimEdit: 'You have unsaved changes to this claim.',
      // Button labels
      leaveAnyway: 'Leave anyway',
      keepEditing: 'Keep editing',
      switchAnyway: 'Switch anyway',
    },
    instantSurvey: {
      // Search and filters
      searchPlaceholder: 'Search instant assessments...',
      addButtonTitle: 'Add new instant assessment',

      // Status filters
      statusAll: 'All',
      statusDraft: 'Draft',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      statusArchived: 'Archived',

      // Status indicators (display text)
      statusLabelDraft: 'Draft',
      statusLabelActive: 'Active',
      statusLabelInactive: 'Inactive',
      statusLabelArchived: 'Archived',

      // Badge
      badgeNew: 'NEW',

      // Empty states
      emptyStateNoAssessments: 'No instant assessments created yet',
      emptyStateNotFound: 'No instant assessments found',

      // Submissions text
      submissions: 'submissions',
      submissionsWithLimit: '{{current}}/{{max}} submissions',
      submissionsWithoutLimit: '{{current}} submissions',

      // SurveyContent - Empty state
      emptyStateTitle: 'No Instant Assessment Selected',
      emptyStateDescription:
        'Select an instant assessment from the sidebar to view and edit its details, or create a new instant assessment to get started.',

      // SurveyContent - Main title
      mainTitle: 'Instant Assessment Configuration',
      mainSubtitle: '{{surveyType}} • Configure and customize your instant assessment',
      mainSubtitleNoType:
        'Assessment Type Not Set • Configure and customize your instant assessment',

      // Section titles
      basicConfigTitle: 'Basic Configuration',
      linkQrCodeTitle: 'Generated Link & QR Code',
      submissionsTitle: 'Submissions Status',

      // Field labels
      fieldAssessmentName: 'Assessment Name',
      fieldAssessmentType: 'Assessment Type',
      fieldSurveyCode: 'Survey Code',
      fieldMaxSubmissions: 'Max Submissions',
      fieldAnonymous: 'Anonymous',

      // Field values
      valueUntitledAssessment: 'Untitled Assessment',
      valueTypeNotSpecified: 'Type not specified',
      valueNoCodeGenerated: 'No code generated',
      valueUnlimited: 'Unlimited',
      valueAllowed: 'Allowed',
      valueNotAllowed: 'Not Allowed',

      // Action tooltips
      editConfigurationTooltip: 'Edit configuration',

      // QR and Link sections
      sectionSurveyLink: 'Survey Link',
      sectionQrCode: 'QR Code',
      downloadQrAriaLabel: 'download QR code',

      // Submissions section
      submissionsLabel: 'Submissions',
      maxSubmissionsLabel: 'Max Submissions',
      createdByText: 'Created by {{creator}} on {{date}}',
    },
    claimUpload: {
      title: 'Claims Upload',
      boxSubtitle: 'Upload an .xlsx file. Validate it first to preview issues without saving, or import to apply the changes.',
      dropHint: 'Drop claims.xlsx or browse',
      dropHintSub: 'Only .xlsx files',
      changeFile: 'Change file',
      removeFile: 'Remove file',
      uploadAndImport: 'Upload & import',
      uploadAndImportHint: 'Imports and saves the claims',
      validateOnly: 'Validate only',
      validateOnlyHint: 'Checks for errors — nothing is saved',
      onlyXlsx: 'Only .xlsx files are supported',
      selectOneFile: 'Please select a single .xlsx file',
      resultTotal: 'Total',
      resultImported: 'Imported',
      resultFailed: 'Failed',
      downloadErrorRows: 'Download error rows ({{count}})',
      addedToHistory: 'New row also added to history below',
      dryRunTitle: 'Validation only — nothing was saved',
      rejectedTitle: 'File rejected — invalid structure',
      issuesCount: '{{count}} issues',
      noErrorDetails: 'No further details provided.',
      rejectedSubtitle: 'No rows were imported. Fix the issues below and re-upload.',
      rejectedSubtitleValidate: 'Validation only — the file was rejected, nothing was saved. Fix the issues below.',
      summaryValidatePassed: 'Validation passed — {{imported}} of {{total}} rows are ready to import. Nothing was saved.',
      validatedSuccess: 'File validated successfully — ready to upload.',
      summaryValidateIssues: 'Validation found {{failed}} issue(s) in {{total}} rows. Nothing was saved.',
      summaryImportComplete: 'All {{imported}} rows imported successfully.',
      summaryImportPartial: 'Import finished — {{imported}} imported, {{failed}} failed.',
      skippedEmptyRows: '{{count}} empty rows skipped',
      statusCompleted: 'Completed',
      statusCompletedWithErrors: 'Completed with errors',
      statusRejected: 'Rejected',
      statusValidationFailed: 'Validation failed',
      historyTitle: 'Upload history',
      filterDateRange: 'Date range',
      filterUploadedBy: 'Uploaded by',
      allUploaders: 'All users',
      colFile: 'File',
      colStatus: 'Status',
      colImpFail: 'Imp/Fail',
      colUploadedBy: 'Uploaded by',
      colUploaded: 'Uploaded',
      errorsLink: 'Errors',
      historyEmpty: 'No uploads yet',
      justNow: 'just now',
      loadMore: 'Load more',
    },
  },
};
